var _defs, _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMintOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 370.73 166.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 185.36,
    cy: 83.26,
    r: 198.83,
    gradientTransform: "translate(0 3.98) scale(1 0.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55e6d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#52dfd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4acbc3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3dabb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#389fa8"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 363.73,
    height: 159.52,
    rx: 30.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.12,7a26.64,26.64,0,0,1,26.61,26.6v99.31a26.64,26.64,0,0,1-26.61,26.61H33.6A26.64,26.64,0,0,1,7,132.91V33.6A26.63,26.63,0,0,1,33.6,7H337.12m0-7H33.6A33.6,33.6,0,0,0,0,33.6v99.31a33.6,33.6,0,0,0,33.6,33.61H337.12a33.61,33.61,0,0,0,33.61-33.61V33.6A33.6,33.6,0,0,0,337.12,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.1,98.11h.62l8.57-32.26q2.7-10.44,8.35-14.31t17-3.86v73.09h-9.82v-62A9,9,0,0,0,134.72,62a23.84,23.84,0,0,0-2.66,6.27L119,113h-9.18L96.66,68.25a24.54,24.54,0,0,0-2.61-6.32A8.83,8.83,0,0,0,90,58.75v62H80.16V47.68q11.39,0,17,3.91t8.4,14.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.09,120.77h-9.81V47.68h9.81Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.52,120.77h-9.81V47.68H213.5q12.94,0,19.32,5.79t6.36,18.22v49.08h-9.81V70.34c0-4.74-1.45-8.16-4.33-10.29s-6.7-3.18-11.44-3.18H197.52Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.58,56.87V47.68h45.94v9.19H276.46v63.9h-9.81V56.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMintOn);
export default __webpack_public_path__ + "static/media/Mint On.73ffa38fedd191286873cefc0b338e93.svg";
export { ForwardRef as ReactComponent };